// Sidebar.tsx
import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../assets/styles/sidebar.css";

const MOBILE_BREAKPOINT = 1024;
const SIDEBAR_WIDTH = 240;

const Sidebar: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [isMobileOrTablet, setIsMobileOrTablet] = useState<boolean>(false);
  const [openMenu, setOpenMenu] = useState<string | null>("organization");
  const [orgStatus, setOrgStatus] = useState<null | string>(null);
  const location = useLocation();

  useEffect(() => {
    const isSmall = window.innerWidth <= MOBILE_BREAKPOINT;
    setIsMobileOrTablet(isSmall);
    setIsOpen(!isSmall);

    const orgData = localStorage.getItem("orgdata");
    if (orgData) {
      const retrievedObject = JSON.parse(orgData);
      if (
        retrievedObject.paymentStatus !== undefined &&
        retrievedObject.paymentStatus !== null
      ) {
        setOrgStatus(retrievedObject.paymentStatus);
      }
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const isSmall = window.innerWidth <= MOBILE_BREAKPOINT;
      setIsMobileOrTablet(isSmall);
      setIsOpen((prev) => (isSmall ? false : prev ?? true));
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isMobileOrTablet) {
      setIsOpen(false);
    }
  }, [location.pathname, isMobileOrTablet]);

  const closeIfMobile = () => {
    if (isMobileOrTablet) setIsOpen(false);
  };

  const toggleMenu = (menuName: string) => {
    setOpenMenu((prev) => (prev === menuName ? null : menuName));
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    "glass-link" + (isActive ? " active" : "");

  return (
    <>
      {isMobileOrTablet && (
        <div className="mobile-toggle-wrap-fixed">
          <button
            className="mobile-toggle"
            onClick={() => setIsOpen((v) => !v)}
            aria-expanded={isOpen}
            aria-label={isOpen ? "Close menu" : "Open menu"}
          >
            <span className="ms-2">{isOpen ? "✖ Close" : "☰ Menu"}</span>
          </button>
        </div>
      )}

      <aside
        className={`glass-sidebar app-sidebar ${isOpen ? "open" : "closed"} ${
          isMobileOrTablet ? "mobile" : "desktop"
        }`}
        style={{ width: SIDEBAR_WIDTH }}
        aria-hidden={!isOpen && isMobileOrTablet}
      >
        <nav aria-label="Main navigation" className="glass-nav">
          <button
            type="button"
            className={`menu-group-toggle ${
              openMenu === "organization" ? "expanded" : ""
            }`}
            onClick={() => toggleMenu("organization")}
            aria-expanded={openMenu === "organization"}
          >
            <span>Organization</span>
            <i
              className={`bi ${
                openMenu === "organization" ? "bi-chevron-up" : "bi-chevron-down"
              }`}
            ></i>
          </button>

          <ul className={`menu-list ${openMenu === "organization" ? "show" : ""}`}>
            <li>
              <NavLink
                to="/mainLayout/organisation-registration"
                className={linkClass}
                onClick={closeIfMobile}
              >
                Organization Registration
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/mainLayout/registrationpayment"
                className={linkClass}
                onClick={closeIfMobile}
              >
                Organization Status Details
              </NavLink>
            </li>
          </ul>

          {orgStatus === "apr" && (
            <>
              <button
                type="button"
                className={`menu-group-toggle ${
                  openMenu === "event" ? "expanded" : ""
                }`}
                onClick={() => toggleMenu("event")}
                aria-expanded={openMenu === "event"}
              >
                <span>Event Management</span>
                <i
                  className={`bi ${
                    openMenu === "event" ? "bi-chevron-up" : "bi-chevron-down"
                  }`}
                ></i>
              </button>

              <ul className={`menu-list ${openMenu === "event" ? "show" : ""}`}>
                <li>
                  <NavLink
                    to="/mainLayout/create-event"
                    className={linkClass}
                    onClick={closeIfMobile}
                  >
                    Event Creation
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/mainLayout/event-view-edit"
                    className={linkClass}
                    onClick={closeIfMobile}
                  >
                    Event Status/Payment Details
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/mainLayout/event-doc-info"
                    className={linkClass}
                    onClick={closeIfMobile}
                  >
                    Register/View Doctor for the Event
                  </NavLink>
                </li>
              </ul>
            </>
          )}
        </nav>
      </aside>

      {isMobileOrTablet && isOpen && (
        <div className="sidebar-overlay" onClick={() => setIsOpen(false)} />
      )}
    </>
  );
};

export default Sidebar;
